var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 100,
    viewBox: "0 0 82 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9364 0L0 49.7372L15.4561 65.1316L80.8492 0.000315457L49.9364 0Z",
    fill: "#47C5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5884 45.8665L22.8516 72.4967L38.3659 88.18L53.7935 72.8141L80.8495 45.8665H49.5884Z",
    fill: "#47C5FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3656 88.1801L50.1103 99.8779H80.8489L53.7928 72.8142L38.3656 88.1801Z",
    fill: "#00569E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6774 72.67L38.1338 57.2754L53.7928 72.8142L38.3653 88.1801L22.6774 72.67Z",
    fill: "#00B5F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3656 88.1802L51.2119 83.9344L52.4879 74.1143L38.3656 88.1802Z",
    fill: "url(#paint0_linear_39_187)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_187",
    x1: 38.9237,
    y1: 77.9111,
    x2: 49.0747,
    y2: 81.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.2b292c5a223f13b2bd9b3119f4df596e.svg";
export { ForwardRef as ReactComponent };